module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_icon-03-fd1e00b7520e77c36520d705c1a01783.png";